import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { ICouponFilterBody, ICouponListingResults } from "@/api_framework/api_modals/coupon";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});

// Searches ONLY base coupons (base_coupon filter) so staff can pick one to copy.
export const useBaseCouponSearchAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [baseCoupons, setBaseCoupons] = useState<ICouponListingResults[]>([]);

  const execute = useCallback(async (search: string) => {
    const body: ICouponFilterBody = {
      status: null,
      is_membership_coupon: null,
      city_ids: null,
      clinic_ids: null,
      coupon_types: null,
      export_csv: false,
      base_coupon: true,
    };
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .post(
          `${COUPON_SERVICE_APIS?.COUPON_LISTING_NEW?.baseURL}?page_number=1&page_size=20&search=${search ?? ""}`,
          body,
          { headers: { Authorization: `${accessToken}`, "Content-Type": "application/json" } },
        )
        .then((res: AxiosResponse<any>) => {
          setBaseCoupons(res.data?.status ? res.data?.data?.results ?? [] : []);
        })
        .catch((e: AxiosError) => {
          setBaseCoupons([]);
          sendCurl(e.config["curlCommand"]);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, []);

  return { execute, baseCoupons };
};
